module.exports = __webpack_public_path__ + "static/media/registered.658985b9.svg";